export const BASE_API_URL = process.env.REACT_APP_API_BASE_URL ? `${process.env.REACT_APP_API_BASE_URL}/api/v1` : 'http://localhost:8080/api/v1';

export const SUPERADMIN = "super.admin";

export const API_URLS = {
  AUTH: {
    LOGIN: `${BASE_API_URL}/auth/login`,
    CHANGE_PASSWORD: `${BASE_API_URL}/auth/change_password`,
    REFRESH_TOKEN: `${BASE_API_URL}/auth/refresh_token`,
  },
  CROP_VARIETY_MACHINE: {
    GET_CROPS_AND_VARIETIES: `${BASE_API_URL}/review/get_crops_and_varieties`,
    GET_MACHINES: `${BASE_API_URL}/review/get_machines`,
  },
  SCANS: {
    GET_SCANS: `${BASE_API_URL}/review/get_scans`,
    GET_SUB_SCANS: `${BASE_API_URL}/review/get_sub_scans`,
    GET_SCAN_DETAILS: `${BASE_API_URL}/review/get_scan_details`,
    GET_SCAN_PDF: `${BASE_API_URL}/review/get_scan_pdf`,
    GET_SCAN_IMAGES: `${BASE_API_URL}/review/get_scan_images`,
    GET_REVIEW_SCAN_DETAILS: `${BASE_API_URL}/review/get_review_scan_details`
  },
  REVIEW_KERNEL:{
     CREATE_REVIEW_KERNEL: `${BASE_API_URL}/review/create_review_kernel`,
     GET_REVIEW_KERNEL: `${BASE_API_URL}/review/get_review_kernal`,
     GET_REVIEW_HISTORY: `${BASE_API_URL}/review/get_review_history`,
  },
  USER:{
     GET_USERS: `${BASE_API_URL}/review/get_users`
  }
};


export const LocationCount = 24;